import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { BaseComponent } from '../base.component';
import { DataService } from '../service/data.service';
import { MessageService } from '../service/message.service';

@Component({
  selector: 'app-message',
  templateUrl: './message.component.html',
  styleUrls: ['./message.component.less'],
  encapsulation:ViewEncapsulation.None
})
export class MessageComponent extends BaseComponent implements OnInit {


  constructor(dataService:DataService, private messageService:MessageService) {
    super(dataService);
  }

  ngOnInit() {

  }

}
